module.exports = "/_next/static/images/4b9336ff502f4472ee1e33b6f8d54f4f-cajitas-left-mobile.jpg";